module.exports = __webpack_public_path__ + "static/passport_current_account-77133f11c6606512b1740948bc7e3aac.pdf";